export enum TOSType {
  MAIN = "MAIN",
  RETAILER = "RETAILER",
  BRAND = "BRAND",
  INSIDER = "INSIDER",
  FAIRE_PAY = "FAIRE_PAY",
  OWF_GRANT = "OWF_GRANT",
}

export enum TOSCountryType {
  USA = "USA",
  CAN = "CAN",
  EU_GENERAL = "EU_GENERAL",
  ITA = "ITA",
  ANZ = "ANZ",
}

export const TOS_ZENDESK_ARTICLE_IDS: {
  [key in TOSType]: {
    [key in "staging" | "prerelease" | "production"]: {
      [key in TOSCountryType]: string;
    };
  };
} = {
  [TOSType.MAIN]: {
    staging: {
      [TOSCountryType.USA]: "16894163676443",
      [TOSCountryType.CAN]: "18393202352411",
      [TOSCountryType.EU_GENERAL]: "16691046191259",
      [TOSCountryType.ITA]: "17015594921755",
      [TOSCountryType.ANZ]: "16894163676443",
    },
    prerelease: {
      [TOSCountryType.USA]: "16894163676443",
      [TOSCountryType.CAN]: "18393202352411",
      [TOSCountryType.EU_GENERAL]: "16691046191259",
      [TOSCountryType.ITA]: "17015594921755",
      [TOSCountryType.ANZ]: "16894163676443",
    },
    production: {
      [TOSCountryType.USA]: "18524497561115",
      [TOSCountryType.CAN]: "18524621308187",
      [TOSCountryType.EU_GENERAL]: "16190332943771",
      [TOSCountryType.ITA]: "18524492703003",
      [TOSCountryType.ANZ]: "18524576619419",
    },
  },
  [TOSType.RETAILER]: {
    staging: {
      [TOSCountryType.USA]: "18422400817563",
      [TOSCountryType.CAN]: "18417960070939",
      [TOSCountryType.EU_GENERAL]: "18421128583707",
      [TOSCountryType.ITA]: "18445474487963",
      [TOSCountryType.ANZ]: "18422400817563",
    },
    prerelease: {
      [TOSCountryType.USA]: "18422400817563",
      [TOSCountryType.CAN]: "18417960070939",
      [TOSCountryType.EU_GENERAL]: "18421128583707",
      [TOSCountryType.ITA]: "18445474487963",
      [TOSCountryType.ANZ]: "18422400817563",
    },
    production: {
      [TOSCountryType.USA]: "18525251461915",
      [TOSCountryType.CAN]: "18524723458075",
      [TOSCountryType.EU_GENERAL]: "18524831904667",
      [TOSCountryType.ITA]: "18525110276379",
      [TOSCountryType.ANZ]: "18525047646363",
    },
  },
  [TOSType.BRAND]: {
    staging: {
      [TOSCountryType.USA]: "18452026390683",
      [TOSCountryType.CAN]: "18458307873051",
      [TOSCountryType.EU_GENERAL]: "18492971658907",
      [TOSCountryType.ITA]: "18514606996251",
      [TOSCountryType.ANZ]: "18452026390683",
    },
    prerelease: {
      [TOSCountryType.USA]: "18452026390683",
      [TOSCountryType.CAN]: "18458307873051",
      [TOSCountryType.EU_GENERAL]: "18492971658907",
      [TOSCountryType.ITA]: "18514606996251",
      [TOSCountryType.ANZ]: "18452026390683",
    },
    production: {
      [TOSCountryType.USA]: "18525420655003",
      [TOSCountryType.CAN]: "18525400693659",
      [TOSCountryType.EU_GENERAL]: "18525516887963",
      [TOSCountryType.ITA]: "18525802318107",
      [TOSCountryType.ANZ]: "18525958655899",
    },
  },
  [TOSType.INSIDER]: {
    staging: {
      [TOSCountryType.USA]: "19455428871835",
      [TOSCountryType.CAN]: "19455428871835",
      [TOSCountryType.EU_GENERAL]: "23358909634203",
      [TOSCountryType.ITA]: "23358909634203",
      [TOSCountryType.ANZ]: "23358909634203",
    },
    prerelease: {
      [TOSCountryType.USA]: "19637077770011",
      [TOSCountryType.CAN]: "29902517084059",
      [TOSCountryType.EU_GENERAL]: "23274853632155",
      [TOSCountryType.ITA]: "23274853632155",
      [TOSCountryType.ANZ]: "29902772531483",
    },
    production: {
      [TOSCountryType.USA]: "19637077770011",
      [TOSCountryType.CAN]: "29902517084059",
      [TOSCountryType.EU_GENERAL]: "23274853632155",
      [TOSCountryType.ITA]: "23274853632155",
      [TOSCountryType.ANZ]: "29902772531483",
    },
  },
  [TOSType.FAIRE_PAY]: {
    staging: {
      [TOSCountryType.USA]: "26147353516059",
      [TOSCountryType.CAN]: "26147353516059",
      [TOSCountryType.EU_GENERAL]: "26147353516059",
      [TOSCountryType.ITA]: "26147353516059",
      [TOSCountryType.ANZ]: "26147353516059",
    },
    prerelease: {
      [TOSCountryType.USA]: "26572239178139",
      [TOSCountryType.CAN]: "26572239178139",
      [TOSCountryType.EU_GENERAL]: "26572239178139",
      [TOSCountryType.ITA]: "26572239178139",
      [TOSCountryType.ANZ]: "26572239178139",
    },
    production: {
      [TOSCountryType.USA]: "26572239178139",
      [TOSCountryType.CAN]: "26572239178139",
      [TOSCountryType.EU_GENERAL]: "26572239178139",
      [TOSCountryType.ITA]: "26572239178139",
      [TOSCountryType.ANZ]: "26572239178139",
    },
  },
  // This is not used as it calls BE for data, but it's here for completeness
  [TOSType.OWF_GRANT]: {
    staging: {
      [TOSCountryType.USA]: "16894163676443",
      [TOSCountryType.CAN]: "18393202352411",
      [TOSCountryType.EU_GENERAL]: "16691046191259",
      [TOSCountryType.ITA]: "17015594921755",
      [TOSCountryType.ANZ]: "16894163676443",
    },
    prerelease: {
      [TOSCountryType.USA]: "16894163676443",
      [TOSCountryType.CAN]: "18393202352411",
      [TOSCountryType.EU_GENERAL]: "16691046191259",
      [TOSCountryType.ITA]: "17015594921755",
      [TOSCountryType.ANZ]: "16894163676443",
    },
    production: {
      [TOSCountryType.USA]: "18524497561115",
      [TOSCountryType.CAN]: "18524621308187",
      [TOSCountryType.EU_GENERAL]: "16190332943771",
      [TOSCountryType.ITA]: "18524492703003",
      [TOSCountryType.ANZ]: "18524576619419",
    },
  },
};
